const engLang = new Intl.DisplayNames(['en'], { type: 'language' });
const regionLang = new Intl.DisplayNames(['en'], { type: 'region' });

const customLanguageMap = {
  ht: 'Haitian Creole (Haiti)',
  hi: 'Hindi (India)',
};

export default {
  getDisplayName(code) {
    let label = 'English';
    if (customLanguageMap[code]) {
      label = customLanguageMap[code];
    } else if (code !== 'en-US') {
      label = engLang.of(code);
    }
    if (code.includes('-') && !label.includes('(')) {
      const region = code.split('-')[1];
      label += ` (${regionLang.of(region)})`;
    }
    return label;
  },
};
